<template>
    <div>
        <div class="father">
            <div class="tab-item">
                <div class="item-btn">
                    <div class="btn-left"  v-show="(timeItem.children[0].themeDetail.needTransitions == 1)">
                        <span>需要转场</span>
                    </div>
                    <div class="btn-left"  v-show="(timeItem.children[0].themeDetail.needTransitions == 0)">
                        <span>不需要转场</span>
                    </div>
                    <div class="btn-right" v-if="showQuotapopbtn && popData[1] && isAllbtn" >
                        <DialogPop
                        v-if="showQuotapopbtn"
                        @confirm="sendBack ()"
                        @getRejectaccount="getRejectaccount"
                        :marLeft="true"
                        isType="1"
                        btnText="退回"
                        centerText="是否确认退回？"
                        :isReject="true"
                        >
                        </DialogPop>
                        <DialogPop
                        v-if="showQuotapopbtn"
                        @confirm="passThrough()"
                        isType="0"
                        btnText="通过"
                        centerText="是否确认通过？"
                        ></DialogPop>
                        
                    </div>
                </div>
                <div class="item-height" v-if="!popData[0].themeDetail.themeLevelCode">
                    <div class="left">初始配额</div>
                    <div class="right">
                        <span>{{formatPrice(popData[0].subAssignObj.assignQty)}} {{ showText }}</span>
                    </div>
                </div>
                <div class="item-height"  v-else>
                    <div class="left">初始配额</div>
                    <div class="right" >
                        <span v-if="popData[0]">{{popData[0].themeDetail.themeLevelName}}：</span>
                        <span v-if="popData[0]" class="right-30">{{formatPrice(popData[0].subAssignObj.assignQty)}} {{ showText }}</span>
                        <span v-if="popData[1]">{{popData[1].themeDetail.themeLevelName}}：</span>
                        <span v-if="popData[1]" class="right-30">{{formatPrice(popData[1].subAssignObj.assignQty)}} {{ showText }}</span>
                        <span v-if="popData[2]">{{popData[2].themeDetail.themeLevelName}}：</span>
                        <span v-if="popData[2]">{{formatPrice(popData[2].subAssignObj.assignQty)}} {{ showText }}</span>
                    </div>
                </div>
                <div class="item-height">
                    <div class="left">单场投入预算</div>
                    <div class="right">
                        <span v-if="popData[0].themeDetail.themeLevelName">{{popData[0].themeDetail.themeLevelName}}：</span>
                        <span v-if="popData[0]" class="right-30">{{formatPrice(popData[0].themeDetail.investUnit)}}</span>
                        <span v-if="popData[1]"> {{popData[1].themeDetail.themeLevelName}}： </span>
                        <span v-if="popData[1]" class="right-30">{{formatPrice(popData[1].themeDetail.investUnit)}}</span>
                        <span v-if="popData[2]">{{popData[2].themeDetail.themeLevelName}}：</span>
                        <span v-if="popData[2]" class="right-30">{{formatPrice(popData[2].themeDetail.investUnit)}} </span>
                    </div>
                </div>
                <div v-if="popData.length == 2">
                    <div class="item-height" 
                        v-if="!(popData[0].subAssignObj.buChangeQty == popData[0].subAssignObj.assignQty  &&
                        popData[1].subAssignObj.buChangeQty == popData[1].subAssignObj.assignQty)"
                        >
                        <div class="left" style="color:#cd1231" v-if="popData[0] && popData[0].subAssignObj.buChangeQty !==null">变更配额</div>
                        <div class="right" style="color:#cd1231">
                            <span v-if="popData[0] && popData[0].subAssignObj.buChangeQty !==null">{{popData[0].themeDetail.themeLevelName}}：</span>
                            <span v-if="popData[0] && popData[0].subAssignObj.buChangeQty !== null" class="right-30"> {{formatPrice(popData[0].subAssignObj.buChangeQty)}} 
                            <span v-if="popData[0] && popData[0].subAssignObj.buChangeQty !== null">{{ showText }}</span>
                            </span>
                            <span v-if="popData[1] && popData[1].subAssignObj.buChangeQty !== null">{{popData[1].themeDetail.themeLevelName}}：</span>
                            <span v-if="popData[1] && popData[1].subAssignObj.buChangeQty !== null" class="right-30"> {{formatPrice(popData[1].subAssignObj.buChangeQty)}} 
                            <span v-if="popData[1] && popData[1].subAssignObj.buChangeQty !== null">{{ showText }}</span>
                            </span>
                        </div>
                    </div>     
                </div>
                <div v-if="popData.length == 3">
                    <div class="item-height" 
                        v-if="!(popData[0].subAssignObj.buChangeQty == popData[0].subAssignObj.assignQty  &&
                        popData[1].subAssignObj.buChangeQty == popData[1].subAssignObj.assignQty &&
                        popData[2].subAssignObj.buChangeQty == popData[2].subAssignObj.assignQty)"
                        >
                        <div class="left" style="color:#cd1231" v-if="popData[0] && popData[0].subAssignObj.buChangeQty !==null">变更配额</div>
                        <div class="right" style="color:#cd1231">
                            <span v-if="popData[0] && popData[0].subAssignObj.buChangeQty !==null">{{popData[0].themeDetail.themeLevelName}}：</span>
                            <span v-if="popData[0] && popData[0].subAssignObj.buChangeQty !== null" class="right-30"> {{formatPrice(popData[0].subAssignObj.buChangeQty)}} 
                            <span v-if="popData[0] && popData[0].subAssignObj.buChangeQty !== null">{{ showText }}</span>
                            </span>
                            <span v-if="popData[1] && popData[1].subAssignObj.buChangeQty !== null">{{popData[1].themeDetail.themeLevelName}}：</span>
                            <span v-if="popData[1] && popData[1].subAssignObj.buChangeQty !== null" class="right-30"> {{formatPrice(popData[1].subAssignObj.buChangeQty)}} 
                            <span v-if="popData[1] && popData[1].subAssignObj.buChangeQty !== null">{{ showText }}</span>
                            </span>
                            <span v-if="popData[2] && popData[2].subAssignObj.buChangeQty !== null">{{popData[2].themeDetail.themeLevelName}}：</span>
                            <span v-if="popData[2] && popData[2].subAssignObj.buChangeQty !== null">
                                {{formatPrice(popData[2].subAssignObj.buChangeQty)}}
                                <span v-if="popData[2].subAssignObj.buChangeQty">{{ showText }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>                                                
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import numberInput from './numberInput.vue'
    import DialogPop from './dialog-pop.vue'
    export default {
      name: 'quotaChange-approval-pop-table',
      props: {
        isAllbtn:{type:Boolean,default:true},
        timeItem:{type:Object, default:()=>{}},
        allTimearr:{type:Object, default:()=>{}},
      },
      components: {
        numberInput,
        DialogPop
      },
      data () {
        return {
            isBtn: true,
            popData:[],
            showQuotapopbtn: true,
            timeList:[],
            showText:'', // 单位 场 售点 街区
            allTimelist: [],
            themeStyleName: '',
            rejectAccount:'', // 退回理由
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
        // 是否间隔大于1
        isInterval() {
            return false
            if ( this.popData.length  ==  1) {
                return false
            } else if (this.popData.length  ==  2) {
                let numBegin = this.popData[0].themeDetail.themeLevelCode.slice(-1)
                let numEnd = this.popData[1].themeDetail.themeLevelCode.slice(-1)
                let Interval =  Math.abs(numBegin-numEnd)
                // console.log(Interval,'Interval');
                if (Interval > 1) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        isNeedtransitions() {
            let isShow =  this.timeItem.children.every(item=>{
                return item.themeDetail.needTransitions == 1
            })
            return isShow
        },
      },
      watch: {},
      created () {
        // console.log(this.timeItem,this.isAllbtn,'配额变更审批详情---孙组件-timeItem');
        this.popData = this.timeItem.children
        this.allTimelist = this.allTimearr.children
        let needTransitions = this.timeItem.children[0].themeDetail.needTransitions
        let pocRelateType = this.timeItem.children[0].themeDetail.pocRelateType
        this.themeStyleName = this.timeItem.children[0].themeDetail.themeStyleName
        // console.log(this.allTimelist,this.isAllbtn,'配额变更审批详情---孙组件-allTimelist');
        if (needTransitions == '1') {
            // 转场
            this.showText = '场'
        } else if (needTransitions == '0') {
            // 不转场
            if (pocRelateType == '1') {
                // 不转场 单售点
                this.showText = '售点'
            } else if (pocRelateType == '0') {
                // 不转场 无售点
                this.showText = '地点'
            } else if (pocRelateType == '2') {
                // 不转场 多售点
                this.showText = '街区'
            }
        }
        // console.log(needTransitions,'needTransitions',pocRelateType,'pocRelateType');
        this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.showQuotabtn()
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },
        // 理由
        getRejectaccount (val) {
            this.rejectAccount = val
        },
        // 驳回
        sendBack () {
            let obj = {popData:this.popData,rejectAccount:this.rejectAccount}
            this.$emit('sendBack',obj)
        },
        // 同意
        passThrough () {
            let item = this.popData
            this.$emit('passThrough',item)
        },
        showQuotabtn () {
            if (this.popData.length == 2) {
                if ((this.popData[0].subAssignObj.buChangeQty == this.popData[0].subAssignObj.assignQty &&
                    this.popData[1].subAssignObj.buChangeQty == this.popData[1].subAssignObj.assignQty) ||
                    (this.popData[0].subAssignObj.buChangeQty == null ||
                    this.popData[1].subAssignObj.buChangeQty == null) ) {
                    this.showQuotapopbtn = false
                }
                
            } else if (this.popData.length == 3) {
                if (this.popData[0].subAssignObj.buChangeQty == this.popData[0].subAssignObj.assignQty &&
                    this.popData[1].subAssignObj.buChangeQty == this.popData[1].subAssignObj.assignQty &&
                    this.popData[2].subAssignObj.buChangeQty == this.popData[2].subAssignObj.assignQty){
                    this.showQuotapopbtn = false
                }  
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.tab-item {
    padding: 0px 10px 20px 30px;
    background-color: #FFFFFF;
    color: #101010;
    // border-radius: 10px;
    font-family: SourceHanSansSC-bold;
    font-size: 14px;
    text-align: left;
    ::v-deep.el-tabs__item.is-active {
        background-color: #FFFFFF;
        color: #409EFF;
    }
    .item-btn {
        display: flex;
        // width: 20%;
        // margin-left: 80%;
        height: 32px;
        line-height: 32px;
        .btn-left {
            width: 50%;
            color: #CD1231;
            font-size: 14px;
            font-weight: 600;
        }
        .btn-right {
            flex: 1;
            display: flex;
            justify-content: flex-end;
        }
    }
    .red {
        color: #CD1231;
        font-size: 16px;
        font-weight: bold;
        margin-top: -40px;
        height: 38px;
        line-height: 38px;
    }
    .item {
        height: 38px;
        line-height: 38px;
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
        }
        .right {
            flex: 1;
            font-size: 14px;
        }
    }
    .item-height {
        height: 45px;
        line-height: 45px;
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
        }
        .right {
            flex: 1;
            font-size: 14px;
            .left-30 {
                margin-left: 30px;
            }
            .right-30 {
                margin-right: 30px;
            }
        }
    }
    .item-height2 {
        height: 100px;
        line-height: 45px;
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
        }
        .right {
            flex: 1;
            font-size: 14px;
            .left-30 {
                margin-left: 30px;
            }
            .right-30 {
                margin-right: 30px;
            }
            .right-40 {
                margin-right: 50px;
            }
            .right-change {
                display: flex;
                .number {
                    width: 150px;
                }
            }
        }
    }
}
</style>
